module.exports = __webpack_public_path__ + "static/media/18ECA23.8e12eea1.jpg";